import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { setSideBarOpenPreference } from 'utils/userPreferences';
import profileMenuEntries from 'constants/profileMenuEntries';
import sideMenuEntries from 'constants/sideMenuEntries';
import SideMenu from './SideMenu';
import TopBar from './TopBar';

import * as Styled from './AppLayout.styled';

const AppLayout = (props) => {
  const {
    children,
    permissions,
    profileName,
    isSideBarOpen,
    featureFlags,
    updateIsSideBarOpen,
  } = props;

  const handleSideBarClose = useCallback(() => {
    setSideBarOpenPreference(false);
    updateIsSideBarOpen(false);
  }, [updateIsSideBarOpen]);

  const handleSideBarOpen = useCallback(() => {
    setSideBarOpenPreference(true);
    updateIsSideBarOpen(true);
  }, [updateIsSideBarOpen]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <Styled.AppContainer>
      <SideMenu
        handleSideBarClose={handleSideBarClose}
        isSideBarOpen={isSideBarOpen}
        userPermissions={permissions}
        featureFlags={featureFlags}
        sideMenuEntries={sideMenuEntries}
        profileName={profileName}
        profileMenuEntries={profileMenuEntries}
      />

      <Styled.VerticalContentContainer>
        <TopBar
          handleSideBarOpen={handleSideBarOpen}
          isSideBarOpen={isSideBarOpen}
        />
        <Styled.PageContainer>{children}</Styled.PageContainer>
      </Styled.VerticalContentContainer>
    </Styled.AppContainer>
  );
};

AppLayout.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  profileName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  isSideBarOpen: PropTypes.bool.isRequired,
  updateIsSideBarOpen: PropTypes.func.isRequired,
};

AppLayout.defaultProps = {};

export default AppLayout;
